import React from 'react';
import { FaTimes } from "react-icons/fa";
import { Button, IconButton } from "@mui/material";
import PopupModal from "../../PopupModal";

const TextModal = (props) => {

    return (
        <PopupModal
            title={props.title}
            triggers={({openModal}) => props.iconButtonOnly ? (
                <IconButton 
                    color={props.color}
                    onClick={openModal}
                    className={props.className}
                    size={props.size}
                >
                    {props.icon}
                </IconButton>
            ) : (
                <Button 
                    variant={'contained'} 
                    color={props.color}
                    onClick={openModal}
                    className={props.className}
                    size={props.size}
                >
                    {props.icon}
                    <span className='ms-1'>{props.title}</span>
                </Button>
            )}
            footTriggers={({closeModal}) => (
                <Button
                    variant={'contained'} 
                    color='black'
                    onClick={closeModal}
                >
                    <FaTimes />
                    <span>Close</span>
                </Button>
            )}
        >
            <div dangerouslySetInnerHTML={{ __html: props.content }} />
        </PopupModal>
    );
}

TextModal.defaultProps = {
    title: '',
    icon: '',
    color: 'primary',
    content: '',
    className: '',
    size: 'normal',
    iconButtonOnly: false,
};

export default TextModal;
